<!--
 * @Description: 系统设置费率设置
 * @Author: xu wei
 * @Date: 2020-03-01 16:48:35
 * @LastEditTime: 2020-09-10 14:49:49
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>费率设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <div class="btns">
        <el-button size="small" type="primary" @click="addrateinfo"
          >添加</el-button
        >
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="商户费率" name="1"> </el-tab-pane>
        <el-tab-pane label="代理费率" name="2"> </el-tab-pane>
      </el-tabs>
      <div class="gs_tablebox">
        <el-table
          ref="moduleTable"
          size="mini"
          :data="tableData"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column type="index" label="编号" width="80">
          </el-table-column>
          <el-table-column label="默认" width="50">
            <template slot-scope="scope">
              <span
                class="gs_rido"
                :class="{
                  checked: scope.row.isDefault,
                  disable: scope.row.isAgency
                }"
                @click="statechange(scope.row)"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="费率名称"> </el-table-column>
          <el-table-column label="创建人/商户">
            <template slot-scope="scope">
              <p style="color:#268000">{{ scope.row.merchantAccount }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="merchantCount" label="用户个数">
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="200">
          </el-table-column>
          <el-table-column prop="name" label="操作" width="180">
            <template slot-scope="scope">
              <!-- <el-button size="mini" type="info" v-if="scope.row.isAgency" @click="editrate(scope.row.id,true)">查看</el-button> -->
              <el-button
                size="mini"
                type="info"
                @click="editrate(scope.row.id, false)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                :disabled="scope.row.isDefault && !scope.row.isAgency"
                @click.prevent="handleClose(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="gs_pagenumber">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
      :title="dialoginfo.flag ? '添加费率' : '编辑费率'"
      :visible.sync="dialoginfo.show"
      @close="dialoginit"
      custom-class="gs_dialog"
      width="1000px"
    >
      <ul class="roadlist clearfix">
        <li>
          <span class="tit" style="width:225px;">费率名称</span>
          <div class="content">
            <el-input
              size="small"
              style="width:205px;"
              v-model="dialoginfo.name"
            ></el-input>
          </div>
        </li>
        <li style="border-right:none">
          <span class="tit" style="width:225px;">一键设置</span>
          <div class="content">
            <el-input
              size="small"
              style="width:205px;"
              type="text"
              :disabled="!dialoginfo.flagchecked"
              v-model="dialoginfo.allset"
              @input="allchange"
            ></el-input>
          </div>
        </li>
        <li style="width:892px">
          <span class="tit" style="width:225px;">费率类型</span>
            <el-radio-group v-model="dialoginfo.isAgency" style="margin:12px">
                  <el-radio :label="false">商户费率</el-radio>
                  <el-radio :label="true">代理费率</el-radio>
                </el-radio-group>
        </li>
        <li
          v-for="(item, i) in dialoginfo.managerRankProductItems"
          :key="'rate' + i"
        >
          <span class="tit">{{ item.productName }}</span>
          <div class="content">
            <el-input
              type="number"
              :disabled="!dialoginfo.flagchecked"
              size="small"
              v-model="item.rate"
            ></el-input>
          </div>
        </li>
      </ul>
      <p class="tc pdt10 pdb10">
        <span v-if="dialoginfo.flagchecked && dialoginfo.show">
          <el-button
            v-if="dialoginfo.flag"
            class="referring"
            size="small"
            type="primary"
            @click="rateadd"
            >提交</el-button
          >
          <el-button
            v-else
            class="referring"
            size="small"
            type="primary"
            @click="rateupdate"
            >提交</el-button
          >
        </span>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1', // tab切换
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialoginfo: {
        flag: true, // 编辑与添加flag
        flagchecked: true, // 代理时弹框只能查看
        show: false, // 弹框显隐
        allset: '', // 一键设置
        id: '',
        applicationUserId: '',
        name: '',
        managerRankProductItems: [],
        isAgency: false
      }
    };
  },
  methods: {
    // tab切换
    handleClick() {
      if (this.activeName === '1') {
        this.pageIndex = 1; // 页码
        this.pageSize = 10; // 每页的条数
        this.total = 0; // 总数据的条数
        this.tableData = [];
        this.getlist();
      } else if (this.activeName === '2') {
        this.pageIndex = 1; // 页码
        this.pageSize = 10; // 每页的条数
        this.total = 0; // 总数据的条数
        this.tableData = [];
        this.getlist();
      }
    },
    // 费率列表
    getlist() {
      this.$api.systemset
        .ratelist({
          IsAgency: this.activeName === '2',
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then(data => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 切换费率的状态
    statechange(item) {
      if (item.isDefault || item.isAgency) {
        return;
      }
      this.$api.systemset
        .ratedefault({ id: item.id })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('切换成功！');
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 删除费率
    ratedel(id) {
      this.$api.systemset
        .ratedelete({ id: id })
        .then(data => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(id) {
      this.$confirm('是否确定删除该费率?')
        .then(() => {
          this.ratedel(id);
        })
        .catch(() => {});
    },
    // 更新时获取数据
    editrate(id, bol) {
      this.$api.systemset
        .updateinfo({ Id: id })
        .then(data => {
          if (data.status === 200) {
            this.dialoginfo.name = data.data.name;
            this.dialoginfo.id = data.data.id;
            this.dialoginfo.applicationUserId = data.data.applicationUserId;
            this.dialoginfo.managerRankProductItems =
              data.data.managerRankProductItems;
            this.dialoginfo.flag = false;
            this.dialoginfo.flagchecked = !bol;
            this.dialoginfo.show = true;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit() {
      this.dialoginfo.flag = true;
      this.dialoginfo.flagchecked = true;
      this.dialoginfo.allset = '';
      this.dialoginfo.name = '';
      this.dialoginfo.id = '';
      this.dialoginfo.applicationUserId = '';
      this.dialoginfo.managerRankProductItems = [];
    },
    // 一键设置
    allchange(val) {
      /* eslint-disable */
      this.dialoginfo.allset = this.dialoginfo.allset.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      );
      /* eslint-enable */
      this.dialoginfo.managerRankProductItems.forEach(item => {
        item.rate = this.dialoginfo.allset;
      });
    },
    // 编辑更新
    rateupdate() {
      if (this.dialoginfo.name === '') {
        this.$messageError('请输入费率名称！');
        return;
      }
      let flag = true;
      this.dialoginfo.managerRankProductItems.forEach(item => {
        if (item.rate === '') {
          flag = false;
        }
      });
      if (flag) {
        this.$api.systemset
          .updaterate({
            id: this.dialoginfo.id,
            name: this.dialoginfo.name,
            applicationUserId: this.dialoginfo.applicationUserId,
            isAgency: this.dialoginfo.isAgency,
            managerRankProductItems: this.dialoginfo.managerRankProductItems.map(
              item => {
                return {
                  productId: item.productId,
                  productName: item.productName,
                  rate: parseFloat(item.rate)
                };
              }
            )
          })
          .then(data => {
            if (data.status === 200) {
              this.dialoginfo.show = false;
              this.$messageSuccess('编辑成功！');
              this.getlist();
            }
          })
          .catch(err => {
            this.$messageError(err.message);
          });
      } else {
        this.$messageError('费率不能为空值！');
      }
    },
    // 添加时获取数据
    addrateinfo(id) {
      this.$api.systemset
        .addinfo()
        .then(data => {
          if (data.status === 200) {
            this.dialoginfo.managerRankProductItems = data.data;
            this.dialoginfo.show = true;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 添加费率
    rateadd() {
      if (this.dialoginfo.name === '') {
        this.$messageError('请输入费率名称！');
        return;
      }
      this.$api.systemset
        .addrate({
          // id: this.dialoginfo.id,
          name: this.dialoginfo.name,
          isAgency: this.dialoginfo.isAgency,
          managerRankProductItems: this.dialoginfo.managerRankProductItems.map(
            item => {
              return {
                productId: item.productId,
                productName: item.productName,
                rate: parseFloat(item.rate)
              };
            }
          )
        })
        .then(data => {
          if (data.status === 200) {
            this.dialoginfo.show = false;
            this.$messageSuccess('添加成功！');
            this.activeName = '1';
            this.getlist();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  position: relative;
  padding: 15px 20px 0;
  background: #fff;
  &::v-deep .el-tabs__header {
    margin-bottom: 0;
    border-bottom: none;
    .el-tabs__item {
      border-bottom: none;
      &.is-active {
        background: #409eff;
        color: #fff;
      }
    }
  }
  .btns {
    position: absolute;
    right: 22px;
    top: 16px;
    z-index: 1;
  }
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tablebox {
  text-align: center;
  td,
  th {
    border: 1px solid #e3e3e3;
    height: 60px;
  }
}
.long {
  width: 100px;
  padding-left: 10px;
}

.referring {
  margin: 10px;
}
.roadlist {
  border: 1px solid #ccc;
  width: 903px;
  li {
    float: left;
    width: 225px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-bottom: -1px;
    &:nth-child(4n + 6) {
      border-right: none;
    }
    &:first-child {
      width: 451px;
    }
    &:nth-child(2) {
      width: 450px;
    }
    .tit {
      float: left;
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid #ccc;
    }
    .content {
      float: left;
      width: 125px;
      height: 32px;
      padding: 4px 9px;
      text-align: center;
    }
  }
}
</style>
